import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import About from '@/views/About.vue'
import EventSingle from '@/views/EventSingle.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/event/:id',
      name: 'eventSingle',
      component: EventSingle
    },
    /* eslint-disable */
    {
        path: '/ext_github', redirect: to => {
            window.location.href = 'https://github.com/khoogheem'
            return '/' // not important since redirecting
        }
    },
    {
        path: '/ext_linkedin', redirect: to => {
            window.location.href = 'https://www.linkedin.com/in/khoogheem'
            return '/' // not important since redirecting
        }
    },
    /* eslint-enable */
  ]
})
